import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    chequesTerceros: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    rptChequesTerceros: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.chequesTerceros = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },

    'INICIALIZAR'(state) {
        state.chequesTerceros = [];
    },
    'SET_CHEQUES_TERCEROS'(state, chequesTerceros) {
        state.chequesTerceros = chequesTerceros;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RPT'(state) {
        state.rptChequesTerceros = [];
    },
    'SET_RPT'(state, rptChequesTerceros) {
        state.rptChequesTerceros = rptChequesTerceros;
    },    
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getChequesTerceros: ( { commit } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            apiAxios.get('chequesTerceros/cartera' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_CHEQUES_TERCEROS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getRptChequesTerceros: ( { commit } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT')

            apiAxios.get('chequesTerceros/cartera/rpt')
                .then(res => {
                    commit('SET_RPT', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getRptChequesTercerosAFecha: ( { commit }, fecha ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT')
            
            let queryString = '?fechaHasta=' + moment(fecha).format('YYYY-MM-DD');

            apiAxios.get('chequesTerceros/cartera/fecha' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },        
};

const getters = {
    getField,

    rptChequesTerceros(state) {
        return state.rptChequesTerceros
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}